module.exports = __webpack_public_path__ + "static/img/logo.6c950163.png";